import { render, staticRenderFns } from "./application-message.vue?vue&type=template&id=4a4ba506&"
import script from "./application-message.vue?vue&type=script&lang=js&"
export * from "./application-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports